module.exports = __webpack_public_path__ + "infocentrum15.jpg?31fc7cd32973e441618c8f6577f3115d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/infocentrum/infocentrum15.jpg
// module id = 267
// module chunks = 0